import styled from 'styled-components';
import { useZoomConfig } from '../TableView/ZoomConfig';

const ButtonZoom = () => {
  const { calendar, handleZoomIn, handleZoomOut } = useZoomConfig();
  if (!calendar) return null;
  return (
    <>
      <Container onClick={handleZoomIn}>{zoom_in}</Container>
      <Container onClick={handleZoomOut}>{zoom_out}</Container>
    </>
  );
};

export default ButtonZoom;

const Container = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  width: 48px;
  height: 48px;
  &:hover {
    background: #f5f5f5;
  }
`;

const zoom_in = (
  <svg xmlns='http://www.w3.org/2000/svg' width='48' height='49' viewBox='0 0 48 49' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 7.90849C13.8998 7.90849 7.33329 14.475 7.33329 22.5752C7.33329 30.6753 13.8998 37.2418 22 37.2418C25.9716 37.2418 29.5745 35.6632 32.2154 33.0992C32.2574 33.0407 32.3046 32.9849 32.3572 32.9323C32.4097 32.8798 32.4655 32.8326 32.524 32.7906C35.088 30.1496 36.6666 26.5468 36.6666 22.5752C36.6666 14.475 30.1001 7.90849 22 7.90849ZM35.1632 33.8528C37.7628 30.8214 39.3333 26.8817 39.3333 22.5752C39.3333 13.0022 31.5729 5.24182 22 5.24182C12.427 5.24182 4.66663 13.0022 4.66663 22.5752C4.66663 32.1481 12.427 39.9085 22 39.9085C26.3065 39.9085 30.2462 38.338 33.2776 35.7384L41.0572 43.518C41.5779 44.0387 42.4221 44.0387 42.9428 43.518C43.4635 42.9973 43.4635 42.153 42.9428 41.6323L35.1632 33.8528ZM22 15.2418C22.7363 15.2418 23.3333 15.8388 23.3333 16.5752V21.2418H28C28.7363 21.2418 29.3333 21.8388 29.3333 22.5752C29.3333 23.3115 28.7363 23.9085 28 23.9085H23.3333V28.5752C23.3333 29.3115 22.7363 29.9085 22 29.9085C21.2636 29.9085 20.6666 29.3115 20.6666 28.5752V23.9085H16C15.2636 23.9085 14.6666 23.3115 14.6666 22.5752C14.6666 21.8388 15.2636 21.2418 16 21.2418H20.6666V16.5752C20.6666 15.8388 21.2636 15.2418 22 15.2418Z'
      fill='#232F3E'
    />
  </svg>
);

const zoom_out = (
  <svg xmlns='http://www.w3.org/2000/svg' width='48' height='49' viewBox='0 0 48 49' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 8.0752C13.9919 8.0752 7.5 14.5671 7.5 22.5752C7.5 30.5833 13.9919 37.0752 22 37.0752C25.9212 37.0752 29.4789 35.5187 32.0889 32.9898C32.1338 32.9285 32.184 32.8699 32.2393 32.8145C32.2947 32.7592 32.3533 32.709 32.4146 32.6641C34.9435 30.0541 36.5 26.4964 36.5 22.5752C36.5 14.5671 30.0081 8.0752 22 8.0752ZM35.3898 33.8436C37.9546 30.7992 39.5 26.8676 39.5 22.5752C39.5 12.9102 31.665 5.0752 22 5.0752C12.335 5.0752 4.5 12.9102 4.5 22.5752C4.5 32.2402 12.335 40.0752 22 40.0752C26.2925 40.0752 30.224 38.5298 33.2684 35.965L40.9393 43.6359C41.5251 44.2216 42.4749 44.2216 43.0607 43.6359C43.6464 43.0501 43.6464 42.1003 43.0607 41.5145L35.3898 33.8436ZM14.5 22.5752C14.5 21.7468 15.1716 21.0752 16 21.0752H28C28.8284 21.0752 29.5 21.7468 29.5 22.5752C29.5 23.4036 28.8284 24.0752 28 24.0752H16C15.1716 24.0752 14.5 23.4036 14.5 22.5752Z'
      fill='#232F3E'
    />
  </svg>
);
